import axios from "axios";
import { requestID, baseUrl, config } from "../common/utils";
// import { config, baseUrl, requestID } from "../../common/utils";

export const callApi = async (route: string, data: any) => {
  const payload = {
    requestID: requestID(),
    ...data,
  };
  const fullUrl = `${baseUrl()}${route}`;
  return await axios.post(fullUrl, payload, config);
};

export const callApiVar = async (route: string, data: any) => {
  const payload = {
    requestID: requestID(),
    data,
  };
  return await axios.post(`${baseUrl()}${route}`, payload, config);
};
